import React from "react";
import { Icon } from "../Icon";
import styles from "./EmptyState.module.css";

export const EmptyState = ({
  icon = "compass",
  title = "No recommendations yet",
  subtitle = "Select your passions to see personalized suggestions",
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Icon name={icon} size={48} />
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
};
